import { render } from "./AddMealForm.vue?vue&type=template&id=f5a6f31c"
import script from "./AddMealForm.vue?vue&type=script&lang=js"
export * from "./AddMealForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__